import { Middleware, configureStore } from '@reduxjs/toolkit';
import { loadStateFromCookie, loadStateFromSessionStorage, saveStateToSessionStorage } from 'utilities';
import rootReducer from './reducers';

// Load the initial state from session storage and cookies
const preloadedState = {
	...loadStateFromSessionStorage(),
	...loadStateFromCookie(),
};

const persistenceMiddleware: Middleware = (store) => (next) => (action) => {
	const result = next(action);

	const state = store.getState() as RootState;

	saveStateToSessionStorage(state);

	// Before the page unloads (e.g., reload or close), set a flag in sessionStorage
	// to indicate that the next load is a reload event.
	window.addEventListener('beforeunload', () => {
		sessionStorage.setItem('reloaded', 'true');
	});

	return result;
};

export const store = configureStore({
	reducer: rootReducer,
	preloadedState,
	// middleware: (getDefaultMiddleware) =>
	// 	getDefaultMiddleware({ serializableCheck: false }).concat(persistenceMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
